export default {
  dataSetName: 'Zeitbedarf',
  head: [
    {
      label: 'Tätigkeit',
      key: 'activity',
      col: 6,
    },
    {
      label: 'Menge\n[h]',
      unit: 'h',
      key: 'amount',
      col: 2,
    },
    {
      label: 'Wert\n[EUR/h]',
      unit: 'EUR',
      key: 'unitPrice',
      col: 2,
    },
    {
      label: 'Kosten\n[EUR]',
      unit: 'EUR',
      key: 'totalPrice',
      col: 2,
    },
  ],
}
